export default {
  edit_selection: 'Editar seleção',
};
